/* eslint-disable no-console */
import React from 'react';
import text from '@ux/text';

/**
 * Converts the legacy configuration object into props for <Dialog/>
 *
 * @param {Object} config - Configuration object
 * @param {String|Node} title - Title of the message
 * @param {Component} footer - Legacy footer for the modal
 * @param {Component} actions - New actions for the modal
 * @returns {Object} - A converted props object for <Dialog/>
 */

export function transform(config) {
  const {
    title,
    footer,
    actions,
    ...rest
  } = config;

  warn(config);

  return {
    title: typeof title === 'string' ? <text.h1 text={ title } as='title'/> : title,
    actions: footer || actions,
    ...rest
  };
}


const warnings = new Set();

/**
 * Warns when the shim is used
 *
 * @param {Object} props - Configuration object
 * @param {Component} footer - Legacy container for the modal
 */
function warn(props) {
  const {
    footer
  } = props;

  if (footer) {
    const warning = 'Prop `footer` for <Modal/> will be removed in v2201, please replace with `actions`';
    !warnings.has(warning) && warnings.add(warning) && console.warn(warning);
  }
}
